
import React from "react";
import { LucideIcon } from "lucide-react";
import { 
  Accordion, 
  AccordionContent, 
  AccordionItem, 
  AccordionTrigger 
} from "@/components/ui/accordion";

export interface ManualSectionProps {
  id: string;
  title: string;
  icon: React.ReactElement;
  content: React.ReactNode;
}

const ManualSection = ({ section }: { section: ManualSectionProps }) => {
  return (
    <AccordionItem key={section.id} value={section.id}>
      <AccordionTrigger className="text-left">
        <div className="flex items-center gap-2">
          {section.icon}
          {section.title}
        </div>
      </AccordionTrigger>
      <AccordionContent className="pt-4">
        {section.content}
      </AccordionContent>
    </AccordionItem>
  );
};

export default ManualSection;
